import React from 'react';
import { message, Row } from 'antd';
import { FormOutlined, AppstoreAddOutlined, TransactionOutlined } from '@ant-design/icons';
import NavItem from '../../components/nav-item';
import List from './list';
import SwitchShop from '../shop/switch-shop';
import can from '../../components/ability';
import { SafeStorage } from '../../utils/jsbridge';
import getCurrentShop from '../shop/get-current-shop';
import getVersionMeta from '../../utils/get-version-meta';

const iconStyle = {
    fontSize: 28,
}

export default () => {
    const accId = window.__baseInfo.accId;
    const [shopId, setShopId] = React.useState(null);
    const [goodsList, setGoodsList] = React.useState({});

    const version = getVersionMeta();
    const versionCheck = async () => {

        if(goodsList?.count >= version.goods) {
            message.error('当前版本已达到最大商品数，请联系销售升级版本');
        }else {
            window.location.href = '/goods/create';
        }
    }

    React.useEffect(() => {
        const fetchShopStore = async () => {
            try {
                let shopStore = await getCurrentShop();
                console.log('Current shop:', shopStore);
                setShopId(shopStore ? shopStore.shopId : null);
            } catch (e) {
                console.error('Failed to parse shop store:', e);
            }
        };
        
        fetchShopStore();
    }, []);

    return (
        <div>
            <SwitchShop onSwitch={(shop) => setShopId(shop.shopId)} />
            <Row gap={20} style={{ margin: '10px 0 0 0' }}>
                {
                    can('create', 'goods') && <NavItem onClick={versionCheck} text="新建商品">
                        <FormOutlined style={iconStyle} />
                    </NavItem>
                }

                {
                    can('proxy', 'goods') && <NavItem href="/goods/proxy" text="代理商品">
                        <TransactionOutlined style={iconStyle} />
                    </NavItem>
                }

                {
                    can('create', 'goods') && <NavItem href="/category" text="分类管理">
                        <AppstoreAddOutlined style={iconStyle} />
                    </NavItem>
                }
            </Row>
            
            <List accId={accId} shopId={shopId} onChange={(res) => setGoodsList(res)} />
        </div>
    )
}